// ============================================
// CONFIGURACIÓN COMPLETA - SO CONSULTORES
// Portal de Clientes con SharePoint
// ============================================

export const msalConfig = {
    auth: {
        clientId: "e7669c9d-d08d-42ba-8f43-aab7cf97903a",
        authority: "https://login.microsoftonline.com/314398f7-8f8f-4765-bbd1-f3bf1a35c694",
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    }
};

export const loginRequest = {
    scopes: [
        "User.Read",
        "Sites.Read.All",
        "Files.Read.All",
        "Files.ReadWrite.All"
    ]
};

// Configuración de SharePoint
export const sharePointConfig = {
    siteUrl: "soconsultorescommx.sharepoint.com",
    sitePath: "/sites/PORTALCLIENTESSOCONSULTORES",
    libraryName: "Documentos compartidos",
    
    // Estas URLs se construirán dinámicamente
    getSiteApiUrl: function() {
        return `https://graph.microsoft.com/v1.0/sites/${this.siteUrl}:${this.sitePath}`;
    }
};

// Configuración: ¿Usar estructura con carpetas de clientes?
export const useClientFolders = true; // Cambiar a false para estructura antigua

// Estructura de carpetas del portal (por cliente)
export const folderStructure = {
    'AVISO REPSE': {
        hasSubfolders: false,
        yearMonth: false,
        color: 'yellow'
    },
    'DECLARACIONES': {
        hasSubfolders: true,
        subfolders: [
            'DECLARACION IVA',
            'DECLARACION ISR',
            'DECLARACION ISR SALARIOS',
            'ACUSE DE DECLARACION',
            'PAGO DE IMPUESTOS'
        ],
        yearMonth: true,
        color: 'blue'
    },
    'DOCUMENTOS IMSS': {
        hasSubfolders: true,
        subfolders: [
            'EMISION MENSUAL (EMA)',
            'EMISION BIMESTRAL (EBA)',
            'RESUMEN DE LIQUIDACION',
            'COMPROBANTE DE PAGO'
        ],
        yearMonth: true,
        color: 'orange'
    },
    'DOCUMENTOS SAT': {
        hasSubfolders: true,
        subfolders: [
            'CONSTANCIA DE SITUACION FISCAL',
            'OPINION DE CUMPLIMIENTO'
        ],
        yearMonth: true,
        color: 'green'
    },
    'DOCUMENTOS LEGALES': {
        hasSubfolders: false,
        yearMonth: false,
        color: 'indigo'
    },
    'ESTADOS DE CUENTA': {
        hasSubfolders: false,
        yearMonth: true,
        color: 'purple'
    },
    'REPORTES': {
        hasSubfolders: false,
        yearMonth: true,
        color: 'violet'
    }
};

export const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export const years = ['2030', '2029', '2028', '2027', '2026', '2025', '2024', '2023'];
